export default {
  Details: {
    Title: 'Ολοκλήρωση Παραγγελίας',

    OrderDetails: {
      Title: 'Η Παραγγελία σας'
    },

    CustomerDetails: {
      Title       : 'Στοιχεία Πελάτη',
      Notification: {
        Login          : 'Έχετε ήδη λογαριασμό;',
        Logout         : 'Καλώς ήρθατε πίσω {user}. Δεν είστε εσείς;',
        NoAccount      : 'Όχι, δεν έχω λογαριασμό. Κάντε',
        ContinueAsGuest: 'ή συνεχίστε ως επισκέπτης.'
      },
      Field: {
        Firstname: {
          Label      : 'Όνομα',
          Placeholder: '',
          Hint       : ''
        },
        Lastname: {
          Label      : 'Επώνυμο',
          Placeholder: '',
          Hint       : ''
        },
        Email: {
          Label      : 'Email',
          Placeholder: '',
          Hint       : ''
        },
        Phone: {
          Label      : 'Κινητό',
          Placeholder: '',
          Hint       : ''
        }
      }
    },

    DeliveryDetails: {
      Title       : 'Στοιχεία Διεύθυνσης',
      Notification: {
        Confirm             : 'Παρακαλούμε επιβεβαιώστε ότι η διεύθυνσή σας έχει συμπληρωθεί σωστά.',
        ConfirmLatLngAddress: 'Παρακαλούμε επιβεβαιώστε ότι η πινέζα βρίσκεται στο σωστό σημείο στο χάρτη και ότι η διεύθυνσή σας έχει συμπληρωθεί σωστά.',
        OutOfBounds         : 'Η διεύθυνση δεν είναι μέσα στα όρια διανομής.',
        Select              : 'Πρέπει να επιλέξετε ή να προσθέσετε διεύθυνση.'
      },
      Field: {
        Autocomplete: {
          Label: 'Αναζήτηση Διεύθυνσης',
          Hint : ''
        },
        AddressComments: {
          Label: 'Οδηγίες διεύθυνσης',
          Hint : 'Επιπλέον οδηγίες για την διεύθυνση.'
        },
        City: {
          Label: 'Περιοχή',
          Hint : 'Εισάγετε την περιοχή της διεύθυνσης.'
        },
        DoorBell: {
          Label: 'Κουδούνι',
          Hint : 'Όνομα που αναγράφεται στο κουδούνι'
        },
        Floor: {
          Label: 'Όροφος',
          Hint : 'πχ. 1ος, Ισόγειο, Μεζονέτα, Μονοκατοικία, κλπ.'
        },
        FriendlyName: {
          Label: 'Φιλική Ονομασία',
          Hint : 'πχ. Σπίτι, Γραφείο, κλπ.'
        },
        Number: {
          Label: 'Αριθμός',
          Hint : 'Εισάγετε τον αριθμό της διεύθυνσης.'
        },
        Postcode: {
          Label: 'Τ.Κ.',
          Hint : 'πχ. 153 54'
        },
        Street: {
          Label: 'Οδός',
          Hint : 'Εισάγετε την οδό της διεύθυνσης.'
        }
      }
    },

    OrderComments: {
      Title: 'Σχόλια Παραγγελίας',
      Field: {
        Comments: {
          Label      : 'Σχόλια Παραγγελίας',
          Placeholder: '',
          Hint       : ''
        }
      }
    },

    PaymentDetails: {
      Title: 'Πληρωμή Παραγγελίας'
    }
  },

  Success: {
    Title: 'Κατάσταση Παραγγελίας',

    Status: {
      Title: 'Κατάσταση Παραγγελίας με κωδικό:',
      Body : 'Θα σε ειδοποιήσουμε μόλις η παραγγελία είναι έτοιμη για παραλαβή από το αντίστοιχο κατάστημα.<br>Θέλετε να αλλάξετε κάτι; Επικοινωνήστε απευθείας με το κατάστημα.'
    },

    Scheduled: {
      Delivery: {
        Title: 'Θα είναι στην πόρτα σου'
      },
      Collection: {
        Title: 'Θα παραλάβεις'
      }
    },

    BrandSlider: {
      Title: 'Τα καταστήματα μας'
    },

    Stores: {
      Title : 'Καταστήματα',
      Status: {
        Title: 'Κατάσταση Παραγγελίας',
        Time : 'Εκτιμώμενος Χρόνος'
      }
    },

    NotFound: {
      Title   : 'Η παραγγελία δεν βρέθηκε!',
      Subtitle: 'Ανακαλύψτε απίθανα καταστήματα, προσθέστε προϊόντα και δημιουργήστε μια παραγγελία!'
    }
  },

  Failure: {
    Title: 'Αποτυχία Παραγγελίας',

    Status: {
      Title: 'Αποτυχία Παραγγελίας',
      Body : 'Δυστυχώς η παραγγελία απέτυχε και δεν εκτελέστηκε. Δοκιμάστε ξανά αργότερα.'
    },

    BrandSlider: {
      Title: 'Τα καταστήματα μας'
    },

    Stores: {
      Title : 'Καταστήματα',
      Status: {
        Time: 'Εκτιμώμενος Χρόνος'
      }
    },

    NotFound: {
      Title   : 'Η παραγγελία δεν βρέθηκε!',
      Subtitle: 'Ανακαλύψτε απίθανα καταστήματα, προσθέστε προϊόντα και δημιουργήστε μια παραγγελία!'
    }
  },

  Button: {
    CompleteOrder: 'Ολοκλήρωση Παραγγελίας'
  }
}
